import { render, staticRenderFns } from "./ProductCrud.vue?vue&type=template&id=d77cd04e&scoped=true"
import script from "./ProductCrud.vue?vue&type=script&lang=js"
export * from "./ProductCrud.vue?vue&type=script&lang=js"
import style0 from "./ProductCrud.vue?vue&type=style&index=0&id=d77cd04e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d77cd04e",
  null
  
)

export default component.exports